import React, { useContext } from 'react';
import styles from './AdviceDisableProduct.styles';
import { AppContext } from 'App.context.js';

export default function AdviseDisableProduct({ product }) {
  const {
    appActions: { translate },
  } = useContext(AppContext);

  let message = translate('hbxProducts.adviceDisableProductText');
  message = message.replace('%s', product);

  return (
    <div>
      <div style={styles.desc}>{message}</div>
    </div>
  );
}
